// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import documentEntity from './entities/document.json';
import documentMenu from '../pages/document/menu.json';
import documentFullForm from '../pages/document/forms/full.json';
import documentContextForm from '../pages/document/forms/context.json';
import documentMiniForm from '../pages/document/forms/mini.json';
import documentLookupForm from '../pages/document/forms/lookup.json';
import documentTableView from '../pages/document/views/table.json';
import documentStagesView from '../pages/document/views/stages.json';
import documentCardsView from '../pages/document/views/cards.json';
import documentSplitView from '../pages/document/views/split.json';
import documentCalendarView from '../pages/document/views/calendar.json';
import documentDashboardView from '../pages/document/views/dashboard.json';

/** Тип запису «Документ» зі сторінками пакета: меню, форми та подання з pages/document/. */
export const documentDefinition: IRecordTypeDefinition = {
  ...documentEntity,
  views: assembleViewSet({
      table: documentTableView,
      stages: documentStagesView,
      cards: documentCardsView,
      split: documentSplitView,
      calendar: documentCalendarView,
      dashboard: documentDashboardView,
  }),
  form: documentFullForm,
  forms: { full: documentFullForm, context: documentContextForm, mini: documentMiniForm, lookup: documentLookupForm },
  menu: documentMenu,
} as IRecordTypeDefinition;
